import { Outlet } from 'react-router'
import { AppShell } from '@mantine/core'
import React, { lazy } from 'react'

const Header = lazy(() => import('../components/Header'))
const Footer = lazy(() => import('../components/Footer'))

/**
 * Renders the app shell for the HireScore Job Board.
 * @returns {JSX.Element}
 */
export default function JobsShell () {
  document.title = 'HireScore job board'

  return (
    <AppShell
      header={{ height: { base: 60, md: 90 } }}
      footer={{ height: { base: 90 } }}
    >
      <AppShell.Header
        bg='white'
        pt='10px'
        pb='10px'
      >
        <Header />
      </AppShell.Header>

      <AppShell.Main
        bg='#FAF9F9'
      >
        <Outlet/>
      </AppShell.Main>

      <AppShell.Footer
        bg='#2A2B2A'
        pt='5px'
        pb='5px'
      >
        <Footer />
      </AppShell.Footer>
    </AppShell>
  )
}
